import ListTripOrders from "../../../../components/@documents/trip_orders/ListTripOrders";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function TripOrdersPage() {

    return (
        <ListTripOrders 
            routeType={routeTypes.admin}
        />
    )
}